import { render, staticRenderFns } from "./StandardPortal.vue?vue&type=template&id=91c832a0&"
import script from "./StandardPortal.vue?vue&type=script&lang=js&"
export * from "./StandardPortal.vue?vue&type=script&lang=js&"
import style0 from "./StandardPortal.vue?vue&type=style&index=0&id=91c832a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports